import Vue from "vue"
import store from "../store"

const MyPlugin = function (Vue) {
  Vue.prototype.$showToast = function (message) {
    Vue.toasted.show(`<div style="padding: 8px 0; font-size: 14px;">${message}</div>`)
  }
  Vue.prototype.$moneyFormat = number => {
    const str = number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
    return str.slice(0, str.length - 3)
  }
}

Vue.use(MyPlugin)
